import { AIModelSound } from './enums/EAISounds';
import AURA_ASTERIA_EN from '@/sounds/aura-asteria-en.wav';
import AURA_LUNA_EN from '@/sounds/aura-luna-en.wav';
import AURA_STELLA_EN from '@/sounds/aura-stella-en.wav';
import AURA_ATHENA_EN from '@/sounds/aura-athena-en.wav';
import AURA_ORION_EN from '@/sounds/aura-orion-en.mp3';
import AURA_ARCAS_EN from '@/sounds/aura-arcas-en.mp3';
import AURA_PERSEUS_EN from '@/sounds/aura-perseus-en.wav';
import AURA_ANGUS_EN from '@/sounds/aura-angus-en.wav';
import AURA_HELIOS_EN from '@/sounds/aura-helios-en.wav';
import AURA_ORPHEUS_EN from '@/sounds/aura-orpheus-en.wav';
import AURA_ZEUS_EN from '@/sounds/aura-zeus-en.wav';

export const CONTACT_SUPPORT_EMAIL = 'contact@myaifrontdesk.com';
export const RECEPTIONIST_NUMBER = '+18484209420';
export const RECEPTIONIST_NUMBER_AUSTRALIA = '+61440135624';
export const RECEPTIONIST_NUMBER_UK = '+447533024217';
export const RECEPTIONIST_NUMBER_NL = '+3197010206577';
export const RECEPTIONIST_NUMBER_US_RESELLER = '+18017841398';
export const RECEPTIONIST_NUMBER_UK_RESELLER = '+447883284637';
export const RECEPTIONIST_NUMBER_AU_RESELLER = '+61440137983';
export const RECEPTIONIST_NUMBER_NL_RESELLER = '+3197010257950';

export const AIModelSounds: { [key in AIModelSound]: HTMLAudioElement } = {
	[AIModelSound.AURA_ASTERIA_EN]: new Audio(AURA_ASTERIA_EN),
	[AIModelSound.AURA_LUNA_EN]: new Audio(AURA_LUNA_EN),
	[AIModelSound.AURA_ATHENA_EN]: new Audio(AURA_ATHENA_EN),
	[AIModelSound.AURA_STELLA_EN]: new Audio(AURA_STELLA_EN),
	[AIModelSound.AURA_ORION_EN]: new Audio(AURA_ORION_EN),
	[AIModelSound.AURA_ARCAS_EN]: new Audio(AURA_ARCAS_EN),
	[AIModelSound.AURA_PERSEUS_EN]: new Audio(AURA_PERSEUS_EN),
	[AIModelSound.AURA_ANGUS_EN]: new Audio(AURA_ANGUS_EN),
	[AIModelSound.AURA_HELIOS_EN]: new Audio(AURA_HELIOS_EN),
	[AIModelSound.AURA_ORPHEUS_EN]: new Audio(AURA_ORPHEUS_EN),
	[AIModelSound.AURA_ZEUS_EN]: new Audio(AURA_ZEUS_EN),
};

export const QUESTIONNAIRE_PLACEHOLDER_TEXT = `Q: What services do you offer?
A: We offer haircuts, beard trims, hot towel shaves, and neck cleanups.

Q: I have a complaint
A: If you have a complaint, you can leave a message by saying "leave a message" and we will get back to you as soon as possible.

Q: Do you have any availability right now?
A: You can check for availability on our website.

Q: I want to cancel my appointment.
A: Please note our cancellation rescheduling policy: 24 hours for haircut services and 48 hours for hair coloring services. To cancel your appointment, use the link in your confirmation email or text message.
`;

export const BOOK_CALL_CALENDLY_URL =
	'https://calendly.com/d/cph3-yqw-sfb/invite-only-ai-front-desk-product-consultation';
export const MY_AI_FRONT_DESK_CONTACT_EMAIL = 'contact@myaifrontdesk.com';

export const MOBILE_WIDTH_THREASHOLD = 767;
export const TABLET_WIDTH_THREASHOLD = 1024;

// Regex Patterns
export const URL_REGEX = /^(http|https):\/\/[^ "]+$/;
export const MIN_10_WORDS_REGEX = /^(?:\b\w+\b[\s\S]*){10,}$/;

export const RESELLER_BOOK_CALL_CALENDLY_URL =
	'https://calendly.com/myaifrontdesk/partner-consultation';

export const ONBOARDING_SETUP_CALENDLY_URL =
	'https://calendly.com/d/cmq2-bzn-bth/ai-front-desk-onboarding-setup-help';

export const IntegrationOAuthProviders = {
	Hubspot: 'hubspot',
};

export const POSTHOG_FEATURE_FLAGS = {
	ONBOARDING_REGISTRATION_REVAMP: {
		key: 'registration-onboarding-revamp',
		variants: {
			NEW: 'new',
			OLD: 'old',
		},
	},
};

export const ONBOADING_STEPS_LENGTH = 8;

export const API_WORKFLOW_TYPES = {
	scenario: 1,
	knowledgeBaseLoader: 2,
};

export const DEFAULT_CALENDLY_LINK =
	'https://calendly.com/d/cmq2-bzn-bth/ai-front-desk-onboarding-setup-help';

export const CSM_MEMBERS = [
	{
		name: 'Alex',
		email: 'alexandra@myaifrontdesk.com',
		imageUrl: 'https://ca.slack-edge.com/T06NC6RK9PA-U089Q0HEHDZ-e1bd1952f69f-512',
		calendlyLink:
			'https://calendly.com/d/crqg-zm2-vz7/ai-front-desk-onboarding-setup-help-alexandra',
	},
	{
		name: 'Lojan Ranara',
		email: 'lojan@myaifrontdesk.com',
		imageUrl: 'https://ca.slack-edge.com/T06NC6RK9PA-U08GM47A739-57ae75788f48-512',
		calendlyLink: 'https://calendly.com/lojan-myaifrontdesk',
	},
	{
		name: 'Jill Singson',
		email: 'jill@myaifrontdesk.com',
		imageUrl: 'https://ca.slack-edge.com/T06NC6RK9PA-U08E4F0BU9L-2c30148fa4b7-512',
		calendlyLink: 'https://calendly.com/d/cnz4-v43-3yd/ai-front-desk-onboarding-setup-help-jill',
	},
	{
		name: 'Rizza',
		email: 'rizza@myaifrontdesk.com',
		imageUrl: 'https://ca.slack-edge.com/T06NC6RK9PA-U08PFGTE8CX-294853262947-512',
		calendlyLink: 'https://calendly.com/d/cm7x-zqz-zzm/ai-front-desk-onboarding-setup-help-rizza',
	},
	{
		name: 'Jay Taller',
		email: 'jay@myaifrontdesk.com',
		imageUrl: 'https://ca.slack-edge.com/T06NC6RK9PA-U08R73GA60H-a20cc45ac413-512',
		calendlyLink: 'https://calendly.com/d/cnw2-x88-wf6/ai-front-desk-onboarding-setup-help-jay',
	},
];

export const INTERRUPTION_SENSITIVITY_DEFAULT_VALUE = 3;

export const DESKTOP_LOGO_S3_URL =
	'https://frontdesk-ui-public.s3.us-east-1.amazonaws.com/logo/logo-final.png';
export const MOBILE_LOGO_S3_URL =
	'https://frontdesk-ui-public.s3.us-east-1.amazonaws.com/logo/mobile-logo-new.jpg';
export const RESELLER_DASHBOARD_VIDEO_URL =
	'https://cdn.prod.website-files.com/646676436cb9dc8974098e06%2F683f62c77e876dda0441db63_Scene-1-transcode.mp4';

export const SHARE_DEMO_CALENDLY_URL =
	'https://calendly.com/d/cph3-yqw-sfb/invite-only-front-desk-ai-configuration-consultation';

export const testimonials = [
	{
		id: 1,
		name: 'Sarah Johnson',
		business: "Johnson's Auto Repair",
		avatar:
			'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=64&h=64&fit=crop&crop=face',
		content:
			'Our AI receptionist has been a game-changer. We used to miss calls when we were under the hood, but now every customer gets immediate attention. Bookings are up 40%! ',
		rating: 5,
	},
	{
		id: 2,
		name: 'Mike Chen',
		business: 'Smile Dental',
		avatar: '/mike-chen.png',
		content:
			"The appointment scheduling feature is incredible. Patients can book 24/7, and the AI handles rescheduling perfectly. It's like having a full-time receptionist at a fraction of the cost.",
		rating: 5,
	},
	{
		id: 3,
		name: 'Lisa Rodriguez',
		business: 'Bella Beauty Salon',
		avatar:
			'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=64&h=64&fit=crop&crop=face',
		content:
			"I was skeptical at first, but clients love how professional and quick the responses are. The AI perfectly answers all my customer's questions and allows me to focus on running my salon!",
		rating: 5,
	},
];

export const businessTypes = [
	{
		id: 'hvac',
		label: 'Field Service Contractors (HVAC/Plumbing/Electrical, etc.)',
		value: 'HVAC',
	},
	{ id: 'auto-sales', label: 'Auto Sales & Service' },
	{ id: 'auto-repair', label: 'Auto Repair' },
	{ id: 'car-dealership', label: 'Car Dealership' },
	{ id: 'other-automotive', label: 'Other Automotive Business' },
	{ id: 'beauty', label: 'Beauty' },
	{ id: 'construction', label: 'Construction' },
	{ id: 'retail', label: 'Retail' },
	{ id: 'food', label: 'Food' },
	{ id: 'legal', label: 'Legal' },
	{ id: 'marketing', label: 'Marketing' },
	{ id: 'technology', label: 'Technology' },
	{ id: 'entertainment', label: 'Entertainment' },
	{ id: 'real-estate', label: 'Real Estate' },
	{ id: 'other', label: 'Other' },
];
